import clsx from 'clsx';

export default function PageShell({ section, title, subtitle, meta, actions, actionsStacked = false, children, className = '', layout = 'default' }) {
  return (
    <div className={clsx(
      '-mt-1',
      layout === 'full' ? 'flex flex-col flex-1 gap-3 min-h-0 overflow-hidden' : 'space-y-4',
      className
    )}>
      <header
        className={clsx(
          'shrink-0 pb-0 w-full',
          actionsStacked
            ? 'flex flex-col gap-3'
            : 'flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3',
        )}
      >
        <div className={actionsStacked ? 'w-full' : undefined}>
          <h1 className="font-display text-lg sm:text-xl font-bold text-dark-900 tracking-tight leading-snug">
            {title}
          </h1>
          {(subtitle || meta) && (
            <p className="text-xs text-surface-500 mt-1 leading-relaxed">
              {subtitle}
              {subtitle && meta && <span className="text-surface-300"> · </span>}
              {meta && <span>{meta}</span>}
            </p>
          )}
        </div>
        {actions && (
          <div
            className={clsx(
              'flex flex-wrap items-center gap-2',
              actionsStacked ? 'w-full' : 'shrink-0 sm:justify-end',
            )}
          >
            {actions}
          </div>
        )}
      </header>
      {layout === 'full' ? (
        <div className="flex-1 min-h-0 overflow-hidden flex flex-col">{children}</div>
      ) : (
        children
      )}
    </div>
  );
}
